import { Component, ViewChild } from '@angular/core';
import { cloneObject, crossfadeAnimation } from '@scisys-uim/uim-common';
import { CustomOption, defaultModules, QuillEditorComponent, QuillModules, QuillToolbarConfig } from 'ngx-quill';
import { BaseTextSectionComponent } from './base-text-section.component';

export const eTimberQuillCustomOptions: CustomOption[] = [{
  import: 'attributors/style/size',
  whitelist: ['small', false, 'large', 'huge', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '36px', '48px']
}];
export const eTimberQuillModulesEdit: QuillModules = customiseModules();

export const eTimberQuillModulesView: QuillModules = {
  toolbar: false
};

export const eTimberQuillClassesEdit: string = 'rich-text-section-editable';
const eTimberQuillClassesView: string = 'rich-text-section-readonly';
const eTimberQuillClassesWithControls = 'rich-text-section-with-controls';
const eTimberQuillClassesWithoutControls = 'rich-text-section-without-controls';
const eTimberQuillClassesViewWithControls: string = eTimberQuillClassesView + ' ' + eTimberQuillClassesWithControls;
const eTimberQuillClassesViewWithoutControls: string = eTimberQuillClassesView + ' ' + eTimberQuillClassesWithoutControls;


@Component({
  selector: 'app-rich-text-section',
  templateUrl: './rich-text-section.component.html',
  styleUrls: ['./rich-text-section.component.scss'],
  animations: [crossfadeAnimation('crossfade')]
})
export class RichTextSectionComponent extends BaseTextSectionComponent {
  classesEdit: string = eTimberQuillClassesEdit;
  classesViewWithControls: string = eTimberQuillClassesViewWithControls;
  classesViewWithoutControls: string = eTimberQuillClassesViewWithoutControls;
  @ViewChild('quillEditor') quillEditor: QuillEditorComponent;

  constructor() {
    super();
  }

  get quillModules(): QuillModules {
    return this.readOnly ? eTimberQuillModulesView : eTimberQuillModulesEdit;
  }
  get quillOptions(): CustomOption[] {
    return eTimberQuillCustomOptions;
  }
}


function customiseModules() {
  const quillModulesEdit: QuillModules = cloneObject(defaultModules);
  const toolbar: QuillToolbarConfig = <QuillToolbarConfig>quillModulesEdit.toolbar;

  customiseToolbar(toolbar);
  return quillModulesEdit;
}

function findSizes(toolbarValues: any[]) {
  return toolbarValues.find(subvalue => Array.isArray(subvalue['size']));
}

function customiseToolbar(toolbar: QuillToolbarConfig) {
  const sizes = findSizes(toolbar.find(value => Array.isArray(value) && findSizes(value)));
  //eTimberQuillCustomOptions[0].whitelist.push(...sizes.size);
  sizes.size = [...eTimberQuillCustomOptions[0].whitelist];
}
